// removed by extract-text-webpack-plugin
module.exports = {"Icon":"src-components-topics----icon-module---Icon---9Bzo0","Icon__img":"src-components-topics----icon-module---Icon__img---1S7gp","Icon__img--portrait":"src-components-topics----icon-module---Icon__img--portrait---1LTvD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/topics/icon.module.scss
// module id = 456
// module chunks = 35783957827783